import './styles/application'

import React from 'react'
import DOM from 'react-dom'
import Presenter from 'microcosm/addons/presenter'
import Repo from './repo'
import getRouterHistory from './config/route-strategy'
import routes from './routes'
import { Router } from 'react-router'

import RA from 'ra-config'

// Reduce down the props we send into our presenters to improve performance
function createElement(Component, { children, location, params, router }) {
  return (
    <Component
      location={location}
      params={params}
      router={router}
      children={children}
    />
  )
}

const repo = new Repo({
  batch: true,
  debug: process.env.NODE_ENV === 'development'
})

const el = document.querySelector('#root')

function render() {
  return DOM.render(
    <Presenter repo={repo}>
      <Router
        history={getRouterHistory()}
        routes={routes}
        createElement={createElement}
        onUpdate={setAnalyticsPageName}
      />
    </Presenter>,
    el
  )
}

// Sets an in-memory value needed to track the current page for Analytics
function setAnalyticsPageName() {  
  const { analyticsUrlPageNameMap: map } = RA.app.page
  const key = Object.keys(map).filter(key => location.href.match(key))

  if (key.length) {
    window.digitalData.page.pageInfo.pageName = map[key[0]]
  }
}

render()

// We're ready now. Remove the preloaded state
document.body.classList.remove('preload')



// WEBPACK FOOTER //
// ./src/index.js